import { render, staticRenderFns } from "./TelaFavoritos.vue?vue&type=template&id=51bfd6c9&"
import script from "./TelaFavoritos.vue?vue&type=script&lang=js&"
export * from "./TelaFavoritos.vue?vue&type=script&lang=js&"
import style0 from "./TelaFavoritos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports